import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryArticleDetails(
  entityType,
  entityId,
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/articles/${entityType}/${entityId}/article-details`,
    method: 'get',
    params: {
    },
  });
}
export function _queryArticles(
  {
    page,
    size,
    direction,
    sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/articles`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 新增
 * @param entityType
 * @param entityId
 * @param details
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _saveArticle(
  entityType,
  entityId,
  details,
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/articles/${entityType}/${entityId}/article-details`,
    method: 'post',
    data: details,
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryArticle(articleId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/articles/${articleId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  title
 * @param  subTitle
 * @param description
 * @param  type
 * @param  coverPath
 * @param videoPath
 * @param jumpType
 * @param targetId
 * @param details
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addArticle(
  {
    title,
    subTitle,
    description,
    type,
    coverPath,
    videoPath,
    jumpType,
    targetId,
    details,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/articles`,
    method: 'post',
    data: {
      title,
      subTitle,
      description,
      type,
      coverPath,
      videoPath,
      jumpType,
      targetId,
      details,
    },
  });
}

/**
 * 更新
 * @param articleId
 * @param  title
 * @param  subTitle
 * @param description
 * @param  type
 * @param  coverPath
 * @param videoPath
 * @param jumpType
 * @param targetId
 * @param details
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateArticle(articleId, {
  title,
  subTitle,
  description,
  type,
  coverPath,
  videoPath,
  jumpType,
  targetId,
  details,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/articles/${articleId}`,
    method: 'patch',
    data: {
      title,
      subTitle,
      description,
      type,
      coverPath,
      videoPath,
      jumpType,
      targetId,
      details,
    },
  });
}

/**
 * 删除
 * @param articleId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteArticle(articleId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/articles/${articleId}`,
    method: 'delete',
  });
}

/**
 * 删除
 * @param articleId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _upArticle(articleId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/articles/${articleId}/up`,
    method: 'patch',
  });
}

/**
 * 删除
 * @param articleId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _downArticle(articleId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/articles/${articleId}/down`,
    method: 'patch',
  });
}

export default {};
